import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class SlugService extends BaseService {

    static url = "slugs";
    static apis = {
        getAll: { path: this.url, method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("slugs");
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: SlugService.apis.getAll.path,
                    method: SlugService.apis.getAll.method,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default SlugService;